// extracted by mini-css-extract-plugin
export default {"card":"c-e_cS","card_styleDefault":"c-e_cT","card_styleRed":"c-e_cU"};